import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

type State = {
  clientIdForTempDashbords: {};
  initFunnelPayload: any;
};

const initialState: State = {
  clientIdForTempDashbords: {},
  initFunnelPayload: {},
};

const sankeyStore = create(
  devtools((set: any) => ({
    ...initialState,
    setInitFunnelPayload: (initFunnelPayload) => set(() => ({ initFunnelPayload })),
    setClientIdForTempDashbords: (clientIdForTempDashbords) =>
      set(() => ({ clientIdForTempDashbords })),
    clientIdForTempDashbords: {},
  })),
);

export default sankeyStore;
